import React, { useContext, useEffect, useState } from "react";
import {
  Grid,
  makeStyles,
  Typography,
  IconButton,
  Tooltip,
  CircularProgress,
  Button,
  Avatar,
  CardContent,
  Card,
  CardMedia,
  Paper,
  ThemeProvider,
  createTheme,
} from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  ApptContext,
  FacilityByDate,
  SchedulesByDate,
  EMRConfig
} from "../../../../../../store"; //FB 8215
import useStyles from "../../../../../../css/styles_PE";
import {
  formatphone,
  GetAvailableSlotsByDate,
} from "../../../../../../api/PE_API";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import Configurations from "../../../../../../config";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import SlotsByDate from "./SlotsByDate";
import { InsertPPLogs } from "../../../../../../api";

// Update log
// FB  6192   02/06/2023  DK  To display the available schedules of the Date
// FB  7882   12/26/2023  SK  Book Appointment Flow isn't working in EDGE and SAFARI browser, Desktop and Smartphones - Patient Portal
// FB  8024   01/03/2024  SK  Including Recent Patient Engagement Enhancements to Patient Portal
// FB  8215   02/01/2024  GA  Portal - Provider images are wrong
// FB  8722   11/06/2024  DK  PE workflows enhancements


const theme = createTheme({
  palette: {
    primary: {
      main: "#18a2b8",
    },
    action: {
      selected: "#8BD0DB",
      hover: "#5DBDCD",
    },
  },
});

const Styles = makeStyles((theme) => ({
  topBarItem: {
    alignSelf: "center",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  borderlessCard: {
    border: "none",
    boxShadow: "none",
  },
  datepickerroot: {
    "& .MuiIconButton-root": {
      color: "#18a2b8",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "2rem",
    },
  },
}));

interface DaySlot {
  dateLabel: string;
  hiddenDateValue: string;
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
}

export default function Schedules_ByDate() {
  const classes = Styles();
  const [indexNumber, setIndexNumber] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [schedules, setSchedules] = useState<SchedulesByDate[]>([]);
  const [todayDate, setToday] = useState<boolean>(false);
  let tempdays: DaySlot[] = [];
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [limited, setLimit] = useState<number>(7);
  const { state, dispatch } = useContext(ApptContext);
  const [weekDay, setWeekDay] = useState<number>(0);
  var week = new Array(
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  );
  const [selectedDate, setSelectedDate] = useState<any>(null);
  const [outofSlots, setOutofSlots] = useState(false);
  const [websiteID, setWebsiteID] = useState(0); //FB 8215
  const styles = useStyles();
  const navigate = useNavigate();
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }
  const handleDateChange = (date: any) => {
    if (date != null && date != "Invalid Date") {
      setSelectedDate(date);
      state.AppointmentDate = date;
      InsertPPLogs(
        "Changed the date to " + date.toDateString() + " in by date flow",
        window.location.href,
        userName,
        ""
      );
    }
  };
  const handleGoBack = () => {
    InsertPPLogs(
      "Clicked on Go Back - Slots page by date flow",
      window.location.href,
      userName,
      ""
    );
    navigate(-1);
  };
  const scrollTo = (ref: any) => {
    if (ref) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  function handleResize() {
    setWindowDimensions(getWindowDimensions());
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [window.innerWidth]);

  useEffect(() => {
    //FB 8215 Begin
    let data = sessionStorage.getItem("EMRConfig");
    if(data!=null){
    let emrConfig = JSON.parse(data) as EMRConfig;
    setWebsiteID(emrConfig.WebsiteID);
    }
    //FB 8215 End
    setIndexNumber(0);
    setLoading(true);
    //FB 8722
    let session_ApptN = sessionStorage.getItem("AppointmentType_N");
    let appt_type_n = session_ApptN != null && session_ApptN != 'undefined' ? Number(session_ApptN) : 0;//FB 8024
    let customAppointmentAdmin = (sessionStorage.getItem("CustomAppointments"));//FB 8024
    let temp: SchedulesByDate[] = [];
    setTimeout(() => {
      (async () => {
        let currentDate = state.AppointmentDate;
        let days = currentDate.getDate();
        //FB 7882 - Begin
        let value = new Date(currentDate.setDate(days));
        let formattedcurrentDate = `${(value.getMonth() + 1).toString().padStart(2, '0')}-${value.getDate().toString().padStart(2, '0')}-${value.getFullYear()}`;
        let splittedDate = value.toLocaleDateString().split("/");
        setWeekDay(currentDate.getDay());
        //FB 8024
        temp = await GetAvailableSlotsByDate(
          formattedcurrentDate,
          state.Facility.ID,
          state.Provider.ID,
          state.AppointmentType,
          0,
          appt_type_n
        );
        //FB 7882 - End
        setLoading(false);
        if (temp.length > 0 && temp[0].FacilityByDate[0].Facility_n != 0) {
          setOutofSlots(false);
          setSchedules(temp);
          //FB 8024 - Begin
          if (customAppointmentAdmin == "true") {
            for (const facility of temp) {
              for (const slotsDate of facility.FacilityByDate) {
                if (slotsDate.ApptTypeSlots.length >= 1) {
                  slotsDate.Slots = slotsDate.ApptTypeSlots.slice();
                }
                else {
                  slotsDate.Slots = [""];
                }
              }
            }
            setSchedules(temp);
          }
          //FB 8024 - End
        } else {
          setOutofSlots(true);
          setSchedules(temp);
        }
      })();
    }, 1000);
  }, [selectedDate]);

  return (
    <React.Fragment>
      {outofSlots ? (
        <Box
          ref={scrollTo}
          sx={{
            width: "100%",
            padding: window.innerWidth < 800 ? "24px 20px" : "24px 80px",
          }}
        >
          <Grid container direction="row" spacing={3}>
            <Grid item xs={12}>
              <Card className={classes.borderlessCard}>
                <CardContent>
                  <Typography variant="h6">
                    <b>
                      {state.AppointmentType === "inoffice"
                        ? "In-office Appointment"
                        : state.AppointmentType === "telederm"
                          ? Configurations.digitalApptType + " Appointment"
                          : ""}
                    </b>
                  </Typography>
                  <Typography variant="h6">{week[weekDay]}</Typography>
                  <Typography variant="subtitle1">
                    {state.AppointmentDate.toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    }).replace(/ /g, " ")}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ThemeProvider theme={theme}>
                  <KeyboardDatePicker
                    id="dateByDate"
                    className={`${classes.datepickerroot} ${classes.topBarItem}`}
                    fullWidth
                    inputVariant="standard"
                    orientation="portrait"
                    value={selectedDate}
                    label="Pick different date"
                    onChange={(date) => handleDateChange(date)}
                    format="MM/dd/yyyy"
                    minDate={new Date()}
                    initialFocusedDate={null}
                    minDateMessage="Date should not be in past"
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            style={{ display: "flex" }}
            direction="row"
            alignContent="center"
            justify="center"
          >
            {loading ? (
              <Grid item xs={12} style={{ margin: "auto" }}>
                <Grid
                  container
                  direction="column"
                  justify="center"
                  alignItems="center"
                  style={{ display: "flex", minHeight: "40vh" }}
                >
                  <CircularProgress />
                </Grid>
              </Grid>
            ) : (
              <div>
                <Grid
                  container
                  spacing={3}
                  direction="row"
                  style={{ display: "flex", minHeight: "40vh" }}
                  alignItems="center"
                  justify="center"
                >
                  <Grid
                    item
                    xs={12}
                    style={{ display: "flex" }}
                    justify="center"
                    alignItems="center"
                  >
                    <Paper
                      style={{
                        backgroundColor: "#EDEEEE",
                        borderRadius: "16px",
                        padding: "10px",
                        fontSize: "smaller",
                      }}
                    >
                      <Typography>
                        There are no online appointments available for this
                        date. Please call {formatphone(state.Facility.Phone)} to
                        book an appointment.
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </div>
            )}
          </Grid>
          <Grid
            container
            spacing={2}
            className={styles.flexend_Grid}
            style={{ marginTop: 10, display: "flex" }}
          >
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className={styles.flexend_Grid}
              style={{ marginTop: 10 }}
            >
              <Button
                id="goBackByDate"
                onClick={handleGoBack}
                variant="contained"
                className={styles.navigationButton}
              >
                Go Back
              </Button>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Box
          ref={scrollTo}
          sx={{
            width: "100%",
            padding: window.innerWidth < 800 ? "24px 20px" : "24px 80px",
          }}
        >
          <Grid container direction="row" spacing={3}>
            <Grid item xs={12}>
              <Card className={classes.borderlessCard}>
                <CardContent>
                  <Typography variant="h6">
                    <b>
                      {state.AppointmentType === "inoffice"
                        ? "In-office Appointment"
                        : state.AppointmentType === "telederm"
                          ? Configurations.digitalApptType + " Appointment"
                          : ""}
                    </b>
                  </Typography>
                  <Typography variant="h6">{week[weekDay]}</Typography>
                  <Typography variant="subtitle1">
                    {state.AppointmentDate.toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    }).replace(/ /g, " ")}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            style={{ display: window.innerWidth <= 768 ? "flex" : "none" }}
          >
            <Grid item xs={window.innerWidth === 768 ? 6 : 12}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ThemeProvider theme={theme}>
                  <KeyboardDatePicker
                    className={`${classes.datepickerroot} ${classes.topBarItem}`}
                    fullWidth
                    inputVariant="standard"
                    orientation="portrait"
                    value={selectedDate}
                    label="Pick different date"
                    onChange={(date) => handleDateChange(date)}
                    format="MM/dd/yyyy"
                    minDate={new Date()}
                    initialFocusedDate={null}
                    minDateMessage="Date should not be in past"
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            style={{ borderBottom: "1px solid rgb(0 0 0 / 25%)" }}
            direction="row"
            alignContent="center"
            justify="center"
          >
            <Grid
              item
              sm={3}
              md={3}
              style={{ display: window.innerWidth > 768 ? "flex" : "none" }}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ThemeProvider theme={theme}>
                  <KeyboardDatePicker
                    id="differentDateByDate"
                    className={`${classes.datepickerroot} ${classes.topBarItem}`}
                    fullWidth
                    inputVariant="standard"
                    orientation="landscape"
                    value={selectedDate}
                    label="Pick different date"
                    onChange={(date) => handleDateChange(date)}
                    format="MM/dd/yyyy"
                    minDate={new Date()}
                    initialFocusedDate={null}
                    minDateMessage="Date should not be in past"
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid
              item
              xs={2}
              sm={1}
              md={1}
              style={{ display: "flex" }}
              justify="center"
            >
              {indexNumber === 0 ? (
                <div></div>
              ) : (
                <Tooltip title="Previous">
                  <IconButton
                    aria-label="previous"
                    onClick={() => setIndexNumber(indexNumber - 1)}
                  >
                    <ArrowBack
                      className={styles.navigationArrows}
                      fontSize="large"
                    />
                  </IconButton>
                </Tooltip>
              )}
            </Grid>
            {loading ? (
              <Grid
                item
                xs={8}
                sm={8}
                md={6}
                style={{ display: "flex" }}
                justify="center"
              >
                <CircularProgress />
              </Grid>
            ) : (
              <Grid
                item
                xs={8}
                sm={8}
                md={6}
                style={{
                  display: "flex",
                  textAlign: window.innerWidth < 768 ? "center" : "left",
                }}
                justify="center"
              >
                {schedules.length === 0 ? (
                  <Card
                    className={styles.bydateProviderCard}
                    style={{ boxShadow: "none" }}
                  >
                    <CardMedia
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Avatar
                        className={styles.slotspage_Avatar}
                        src={"/Images/Providers/"+websiteID +"/"+ state.Provider.ID + ".jpg"} // FB 8215 -Added websiteID to the source path
                      />
                    </CardMedia>
                    <CardContent>
                      <Typography variant="h6">
                        <b>{state.Provider.Name}</b>
                      </Typography>
                      <Typography style={{ fontSize: "smaller" }}>
                        {state.Provider.JobTitle}
                        <br />
                        {state.Provider.Bio}
                      </Typography>
                    </CardContent>
                  </Card>
                ) : (
                  <Card
                    className={styles.bydateProviderCard}
                    style={{ boxShadow: "none" }}
                  >
                    <CardMedia
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Avatar
                        className={styles.slotspage_Avatar}
                        src={
                          "/Images/Providers/"+websiteID+"/" +
                          schedules[indexNumber].Employee_N +
                          ".jpg"
                        } // FB 8215 -Added websiteID to the source path
                      />
                    </CardMedia>
                    <CardContent>
                      <Typography variant="h6">
                        <b>
                          {schedules[indexNumber].Employee_First_Name}{" "}
                          {schedules[indexNumber].Employee_Last_Name}
                        </b>
                      </Typography>

                      <Typography style={{ fontSize: "smaller" }}>
                        {schedules[indexNumber].Employee_Job_Title}
                        <br />
                        {schedules[indexNumber].Employee_Bio}
                      </Typography>
                    </CardContent>
                  </Card>
                )}
              </Grid>
            )}
            <Grid
              item
              xs={2}
              sm={1}
              md={1}
              style={{ display: "flex" }}
              justify="center"
            >
              {indexNumber + 1 === schedules.length ? (
                <div></div>
              ) : (
                <Tooltip title="Next">
                  <IconButton
                    aria-label="next"
                    onClick={() => setIndexNumber(indexNumber + 1)}
                  >
                    <ArrowForward
                      className={styles.navigationArrows}
                      fontSize="large"
                    />
                  </IconButton>
                </Tooltip>
              )}
            </Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            style={{ display: "flex" }}
            direction="row"
            alignContent="center"
            justify="center"
          >
            {loading ? (
              <Grid item xs={12} style={{ margin: "auto" }}>
                <Grid
                  container
                  direction="column"
                  justify="center"
                  alignItems="center"
                  style={{ display: "flex", minHeight: "40vh" }}
                >
                  <CircularProgress />
                </Grid>
              </Grid>
            ) : schedules[indexNumber].FacilityByDate[0].Slots.length === 0 &&
              schedules[indexNumber].NextAvailability === null ? (
              <div>
                <Grid
                  container
                  spacing={3}
                  direction="row"
                  style={{ display: "flex", minHeight: "40vh" }}
                  alignItems="center"
                  justify="center"
                >
                  <Grid
                    item
                    xs={12}
                    style={{ display: "flex" }}
                    justify="center"
                    alignItems="center"
                  >
                    <Paper
                      style={{
                        backgroundColor: "#EDEEEE",
                        borderRadius: "16px",
                        padding: "10px",
                        fontSize: "smaller",
                      }}
                    >
                      <Typography>
                        There are no online appointments available for this
                        provider. Please call{" "}
                        {formatphone(
                          schedules[indexNumber].FacilityByDate[0]
                            .SchedulinPhone
                        )}{" "}
                        to book an appointment.
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </div>
            ) : (
              <Grid
                item
                xs={12}
                style={{ maxHeight: "70vh", overflowY: "auto" }}
              >
                {schedules[indexNumber].FacilityByDate.map(
                  (ele: FacilityByDate, index: number) => {
                    return (
                      <SlotsByDate
                        Schedules={schedules}
                        FacilityByDate={ele}
                        Limited={limited}
                        indexNumber={indexNumber}
                        Index={index}
                        isLoading={setLoading}
                      />
                    );
                  }
                )}
              </Grid>
            )}
          </Grid>

          <Grid
            container
            spacing={2}
            className={styles.flexend_Grid}
            style={{ marginTop: 10, display: "flex" }}
          >
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className={styles.flexend_Grid}
              style={{ marginTop: 10 }}
            >
              <Button
                onClick={handleGoBack}
                id="goBackDatePage"
                variant="contained"
                className={styles.navigationButton}
              >
                Go Back
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
    </React.Fragment>
  );
}
